import { criar } from "@/api/registroDeLiberacao";
import { RegistroDeLiberacaoDTO } from "@/models";
import { RegistroDeLiberacaoServiceAdapter } from "@/usecases/usuario/adapter/RegistroDeLiberacaoServiceAdapter";
import { AxiosRequestConfig } from "axios";
import { injectable } from "inversify-props";

@injectable()
export class RegistroDeLiberacaoService implements RegistroDeLiberacaoServiceAdapter {
	criar = async (registroDeLiberacao: RegistroDeLiberacaoDTO, config?: AxiosRequestConfig) => await criar(registroDeLiberacao, config)
}
